import * as React from 'react';
import { PaymentPurpose } from '@models/Payment';

import { ModalProps } from '@common/components/modal/_components/modal.component';
import { SavedCreditCard } from '@models/Account';
import { OptionsViewModel } from '@models/common.models';
import { ContractViewModel, ContractOrderType, EmailNotificationViewModel } from '@models/Contract';
import { PaymentViewModel, PaymentType } from '@models/Payment';

import { ContractResaleEmail } from '../../contract-resale-email/contract-resale-email.container';
import { HostedPayment } from 'src/payment/_components/gateway/hosted-payment.container';

export interface ContractPaymentComponentProperties {
  readonly hideStepLabel?: boolean;
  readonly affiliatedAccounts?: OptionsViewModel[];
  readonly contractEndDate?: Date;
  readonly contractId: number;
  readonly contractVM: ContractViewModel;
  readonly isRenewal?: boolean;
  readonly savedCreditCards?: SavedCreditCard[];
  readonly sentEmails?: boolean;
  readonly totalPrice?: number;
  readonly propertySalesTypes: Array<OptionsViewModel>;
  readonly isNextDisabled: boolean;
  readonly contractEmailList: Array<EmailNotificationViewModel>;
  readonly buttonRef: (button: HTMLButtonElement) => void;
  readonly initialize: () => void;
  readonly saveContract: (contractVM: ContractViewModel, callback: () => void) => void;
  readonly hostedPayment: boolean;
  readonly submit: (
    isRenewal: boolean,
    contractId?: number,
    payment?: PaymentViewModel,
    demandLetter?: boolean,
    contractBalance?: number,
    emailList?: Array<EmailNotificationViewModel>
  ) => void;
  readonly toggleModal: (modalProps?: ModalProps) => void;
  readonly orderType?: ContractOrderType;
  readonly cancelSendEmails: () => void;
  readonly contractBalance?: number;
  readonly getContractEmailList: (contractId: number) => Promise<void>;
}

export class ContractPaymentComponent extends React.Component<ContractPaymentComponentProperties> {
  constructor(props: ContractPaymentComponentProperties) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }
  public componentDidMount(): void {
    this.props.initialize();
    this.props.getContractEmailList(this.props.contractId);
  }

  public render(): JSX.Element {
    if (this.props.contractVM && this.props.contractVM.resaleId && this.props.contractId && !this.props.sentEmails) {
      this.renderEmailModal();
    }

    return (
      <>
        {this.props.hideStepLabel ? null : <h2>Step 7: Payment</h2>}
        <HostedPayment
          contractId={this.props.contractId}
          affiliatedAccounts={this.props.affiliatedAccounts}
          contractEndDate={this.props.contractEndDate}
          paymentPurpose={PaymentPurpose.Contract}
          totalPrice={
            this.props.contractBalance && this.props.contractBalance > 0
              ? this.props.contractBalance
              : this.props.totalPrice
          }
          savedCreditCards={this.props.savedCreditCards}
          submit={this.handleSubmit}
          submitButtonRef={this.props.buttonRef}
          isDemandLetterEnabled={!this.props.isRenewal && this.props.orderType === ContractOrderType.RealtyEscrow}
          isDemandLetterDefault={
            !this.props.isRenewal && this.props.propertySalesTypes.length
              ? this.props.orderType === ContractOrderType.RealtyEscrow
              : false
          }
          orderType={this.props.orderType}
        />
      </>
    );
  }

  private handleSubmit = (model: PaymentViewModel) => {
    if (this.props.isRenewal && this.props.contractVM) {
      this.props.saveContract(this.props.contractVM, this.submitPayment.bind(this, model));
    } else {
      this.submitPayment(model);
    }
  };

  private renderEmailModal(): void {
    this.props.toggleModal({
      title: 'Email Resale',
      closeLabel: 'Cancel',
      hideX: true,
      hideSave: true,
      component: ContractResaleEmail,
      closeCallback: this.props.cancelSendEmails,
      childProps: {
        toggleModal: this.props.toggleModal,
        id: this.props.contractId ? this.props.contractId : null
      }
    });
  }

  private submitPayment(payment?: PaymentViewModel, demandLetter?: boolean): void {
    let newPayment = {} as PaymentViewModel;
    if (payment) {
      const paymentType = payment.paymentTypeInitial.toString();
      if (paymentType === PaymentType.ACH.toString()) {
        newPayment = {
          ...payment,
          paymentDemandLetterInitial: undefined,
          paymentCreditCardInitial: undefined
        };
      }
      if (paymentType === PaymentType.CreditCard.toString()) {
        newPayment = {
          ...payment,
          paymentDemandLetterInitial: undefined,
          paymentACHInitial: undefined
        };
      }
      if (paymentType === PaymentType.DemandLetter.toString()) {
        newPayment = {
          ...payment,
          paymentACHInitial: undefined,
          paymentCreditCardInitial: undefined
        };
        demandLetter = true;
      }
    }

    // This is checking to see which option is selected, and only passing the applicable fields to the backend.
    // It has to be done this way instead of clearing the store/form so that users do not lose data when clicking between ACH/CC/Demand Letter.
    if (!this.props.isNextDisabled) {
      // don't let it resubmit
      let button: HTMLElement | null = document.getElementById('wizardNextButton');
      if (button) {
        (button as HTMLButtonElement).disabled = true;
      }
      this.props.submit(
        this.props.isRenewal || false,
        this.props.contractId,
        newPayment,
        demandLetter,
        this.props.contractBalance,
        this.props.contractEmailList
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/contract-payment/_components/contract-payment.component.tsx